import { TextBlock } from '../../model'

class Codeblock extends TextBlock {}

Codeblock.type = "codeblock"

export default Codeblock
